<script>
    import { debounce as _debounce } from 'lodash';
    import SingleSelector from '../../../vue-app/components/SingleSelector.vue';
    import bus from '../../utils/eventBus';

    export default {
        name: 'InteractiveSolutionExplorer',
        components: { SingleSelector },
        props: {
            solutions: {
                type: Array,
                default: () => []
            }
        },
        data() {
            const safeSolutions = this.solutions;
            const baseFirst = { ...safeSolutions[0], hotspots: safeSolutions[0].hotspots.filter(Boolean) };

            return {
                bus: bus,
                mainImage: baseFirst,
                selectedHotspot: baseFirst,
                hotspots: safeSolutions.slice(1).filter(Boolean),
                infoBoxShown: null,
                selectedFilter: null,
                showInlineFilters: true,
                inlineFiltersWidth: 0,
                hideHotspotFilters: baseFirst.hideFilters,
                selectedHotspotTabId: 0,
                clickIndex: 0
            };
        },
        computed: {
            safeSolutions() {
                return Array.isArray(this.solutions) ? this.solutions.filter(Boolean) : [];
            },
            bigPopupShown() {
                return !!(this.selectedHotspot && this.selectedHotspot.infoBox && (this.selectedHotspot.infoBox.isBigPopup || this.selectedHotspot.infoBox.isBigPopupWithTabs));
            },
            isMobile() {
                return window.innerWidth < 722;
            }
        },
        watch: {
            selectedHotspot(newVal) {
                if (!newVal || typeof newVal !== 'object') return;
                const url = new URL(window.location.href);
                if (newVal.id != null) {
                    url.searchParams.set('hotspotId', newVal.id);
                    window.history.replaceState({}, '', url.toString());
                }
                this.$nextTick(() => {
                    if (this.inlineFiltersWidth === 0 && this.$refs.filters && !this.hideHotspotFilters) {
                        this.inlineFiltersWidth = this.$refs.filters.offsetWidth;
                        this.handleShowInlineFilters();
                    }
                    if (newVal.infoBox && newVal.infoBox.tabs) {
                        this.checkForTinymceLinks();
                    }
                });
            }
        },
        created() {
            this.bus.$on('dropdownChange', (filter, id) => {
                if (id === 'dropdown-filters') {
                    const f = normalizeDropdown(filter);
                    this.handleFilterClick(f ? f.value : null, f ? f.name : null);
                }
            });
        },
        mounted() {
            this.inlineFiltersWidth = this.hideHotspotFilters || !this.$refs.filters ? 0 : this.$refs.filters.offsetWidth;
            this.handleShowInlineFilters();
            window.addEventListener('resize', _debounce(() => { this.handleShowInlineFilters(); }, 500));
            this.$refs.hotspotImage?.addEventListener('load', () => {
                this.$refs.hotspotImage.classList.remove('loading');
            });
            window.dataLayer = window.dataLayer || [];
            const params = new URLSearchParams(window.location.search);
            const hotspotId = params.get('hotspotId');
            if (hotspotId) {
                const selectedHs = this.safeSolutions.filter(solution => solution && solution.id === parseInt(hotspotId));
                if (selectedHs.length) {
                    this.handleHotspotClick(selectedHs[0]);
                    const $tool = $(this.$refs.tool);
                    if ($tool && $tool.offset()) {
                        $('html, body').animate({ scrollTop: ($tool.offset().top - 2 * 69) }, 1000);
                    }
                }
            }
        },
        methods: {
            createFallback() {
                return {
                    id: 0,
                    name: '',
                    image: '',
                    hideFilters: true,
                    hotspots: [],
                    infoBox: null,
                    mobileHotspotsWithNumbers: false
                };
            },
            hotspotCoords(hotspot) {
                if (hotspot) {
                    if (this.isMobile && hotspot.mobileX && hotspot.mobileY) {
                        return { left: hotspot.mobileX, top: hotspot.mobileY };
                    }
                    return { left: hotspot.x, top: hotspot.y };
                }
            },
            getPopupPosition(hotspot, isOnSide) {
                if (!hotspot) return { left: 'auto' };
                let isLeftAligned = hotspot.x < 50;
                let hotspotCoords = this.hotspotCoords(hotspot);
                return isOnSide ? { left: 'auto' } : (isLeftAligned ? { left: hotspotCoords.left + '%', top: hotspotCoords.top + '%' } : { left: 'auto', right: (100 - hotspotCoords.left) + '%', top: hotspotCoords.top + '%' });
            },
            setOpenDialog(id) {
                if (id === null) {
                    this.infoBoxShown = id;
                    this.$refs.tool?.removeEventListener('click', this.handleClickOutsideDialog);
                } else {
                    if (this.infoBoxShown === id) {
                        const active = document.querySelector('.activePopup');
                        active && active.blur();
                        this.infoBoxShown = null;
                        this.$refs.tool?.removeEventListener('click', this.handleClickOutsideDialog);
                    } else {
                        this.infoBoxShown = id;
                        setTimeout(() => {
                            const active = document.querySelector('.activePopup');
                            active && active.focus();
                            this.$refs.tool?.addEventListener('click', this.handleClickOutsideDialog);
                        }, 100);
                    }
                }
            },
            dataLayerPush(key, value) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'solution_explorer_usage',
                    interaction: { step: this.clickIndex, key, value }
                });
                this.clickIndex++;
            },
            handleFilterClick(id, filterName) {
                if (id === this.selectedFilter) {
                    this.selectedFilter = null;
                    this.dataLayerPush('filter', null);
                } else {
                    this.selectedFilter = parseInt(id);
                    this.dataLayerPush('filter', filterName);
                }
            },
            setHotspot(hotspot) {
                if (this.$refs.hotspotImage) this.$refs.hotspotImage.classList.add('loading');
                this.infoBoxShown = null;
                this.selectedHotspot = hotspot;
                this.selectedHotspotTabId = 0;
                this.hideHotspotFilters = !!hotspot.hideFilters;
            },
            handleHotspotClick(hotspot) {
                if (!hotspot) return;
                if (hotspot.infoBox) {
                    if (hotspot.infoBox.isBigPopup || hotspot.infoBox.isBigPopupWithTabs) {
                        this.setHotspot(hotspot);
                        this.setOpenDialog(hotspot.id);
                    } else {
                        this.setOpenDialog(hotspot.id);
                    }
                } else if (hotspot.directLink) {
                    window.location.href = hotspot.directLink;
                } else if (hotspot.anchor) {
                    let anchor = document.querySelector(hotspot.anchor.startsWith('#') ? hotspot.anchor : '#' + hotspot.anchor);
                    if (anchor) {
                        let menuHeight = document.querySelector('.megamenu')?.offsetHeight || 0;
                        anchor.style.position = 'relative';
                        anchor.style.top = (menuHeight + 20) * -1 + 'px';
                        anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        anchor.style.top = 0;
                    }
                } else if (hotspot.image) {
                    this.setHotspot(hotspot);
                }
                this.dataLayerPush('hotspot', hotspot.name);
            },
            handleLinkClick(e, value) {
                e.preventDefault();
                this.dataLayerPush('link', value);
                this.$nextTick(() => { e.target.click(); });
            },
            handleSeeMoreClick(hotspot) {
                this.setHotspot(hotspot);
                this.dataLayerPush('hotspot', hotspot.name);
            },
            handleTabClick(index, tabName) {
                this.selectedHotspotTabId = index;
                this.dataLayerPush('tab', tabName);
                this.$nextTick(() => { this.checkForTinymceLinks(); });
            },
            checkForTinymceLinks() {
                const activePopup = this.$refs.tool?.querySelector('.activePopup');
                if (activePopup) {
                    $(activePopup).find('a').on('click', (e) => {
                        this.handleLinkClick(e, e.target.innerText);
                        $(e.target).off('click');
                    });
                }
            },
            getBackInNavigation() {
                let selected = this.mainImage;
                this.safeSolutions.forEach(item => {
                    if (item && Array.isArray(item.hotspots) && item.hotspots.find(h => h && h.id === this.selectedHotspot.id)) {
                        selected = item;
                    }
                });
                this.setHotspot(selected);
            },
            getHotspotById(id) {
                if (id == null) return this.createFallback();
                return this.hotspots.find(h => h && h.id === id) || this.createFallback();
            },
            getHotspotColorClass(color) {
                return color ? 'hotspot__icon--' + color : '';
            },
            isActiveFilter(id) {
                return this.selectedFilter && parseInt(id) === this.selectedFilter;
            },
            hotspotShouldShow(hotspotFilters) {
                return !this.selectedFilter || (Array.isArray(hotspotFilters) && hotspotFilters.find(f => f === this.selectedFilter));
            },
            handleClickOutsideDialog(e) {
                const target = e.target;
                if (target.closest && target.closest('.popup')) return;
                if (!(target.closest && target.closest('.hotspot'))) {
                    this.setOpenDialog(null);
                }
            },
            handleShowInlineFilters() {
                if (!this.hideHotspotFilters && this.$refs.filters) {
                    this.showInlineFilters = this.$refs.filters.offsetWidth > this.inlineFiltersWidth;
                }
            },
            renderHotspotTag(id, name) {
                let filter = this.$refs.icons?.querySelector('#tag-' + id);
                let html = '';
                if (filter) html = filter.innerHTML;
                html += name || '';
                return html;
            },
            renderHotspotTabIcon(id) {
                let filter = this.$refs.icons?.querySelector('#tag-' + id);
                let html = '';
                if (filter) html = filter.innerHTML;
                return html;
            }
        }
    };
</script>
